'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = exports.classConstraints = exports.name = exports.record = exports.thunk = exports.method = exports.uncurriedFunction = exports.fn = exports.list = exports.constrainedType = exports.typevar = exports.typeConstructor = undefined;

var _ramda = require('ramda');

var _nearley = require('nearley');

var _nearley2 = _interopRequireDefault(_nearley);

var _grammar = require('./grammar');

var _grammar2 = _interopRequireDefault(_grammar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseFrom = (0, _ramda.curry)(function parseFrom(start, s) {
  var parser = new _nearley2.default.Parser(_grammar2.default.ParserRules, start);

  return parser.feed(s).results[0];
});

var typeConstructor = exports.typeConstructor = parseFrom('typeConstructor');
var typevar = exports.typevar = parseFrom('typevar');
var constrainedType = exports.constrainedType = parseFrom('constrainedType');
var list = exports.list = parseFrom('list');
var fn = exports.fn = parseFrom('function');
var uncurriedFunction = exports.uncurriedFunction = parseFrom('uncurriedFunction');
var method = exports.method = parseFrom('method');
var thunk = exports.thunk = parseFrom('thunk');
var record = exports.record = parseFrom('record');
var name = exports.name = parseFrom('name');
var classConstraints = exports.classConstraints = parseFrom('classConstraints');
var parse = exports.parse = parseFrom('declaration');

exports.default = {
  typeConstructor: typeConstructor,
  typevar: typevar,
  constrainedType: constrainedType,
  list: list,
  fn: fn,
  uncurriedFunction: uncurriedFunction,
  method: method,
  thunk: thunk,
  record: record,
  name: name,
  classConstraints: classConstraints,
  parse: parse
};


//////////////////
// WEBPACK FOOTER
// /home/circleci/project/node_modules/hm-parser/dist/index.js
// module id = 1221
// module chunks = 0